const getBoolFromVar = require("./getBoolFromVar");

module.exports = function getSiteMetaData() {
	const siteMetaSchema = {
		title: { env: "CLF_SITE_TITLE", default: "New Gatsby Site" },
		subtitle: { env: "CLF_SITE_SUBTITLE", default: "" },
		titleAsText: { env: "CLF_SITE_TITLE_AS_TEXT", default: "0" },
		hasSearch: { env: "CLF_HAS_SEARCH", default: false, type: "boolean" },
		hasCart: { env: "CLF_HAS_CART", default: false, type: "boolean" },
		cartRoute: { env: "CLF_CART_ROUTE", default: "/cart" },
		designSystem: { env: "CLF_DESIGN_SYSTEM", default: "material" },
		themeName: { env: "CLF_THEME", default: "" },
		description: { env: "CLF_SITE_DESCRIPTION", default: "" },
		url: { env: "CLF_SITE_URL", default: "http://localhost:8000" },
		siteUrl: { env: "CLF_SITE_URL", default: "http://localhost:8000" },
		drupalUrl: { env: "CLF_BACKEND_URL", default: "" },
		privateRoute: { env: "CLF_PRIVATE_ROUTE", default: "" },
		allowRegistration: { env: "CLF_ALLOW_REGISTRATION", default: false, type: "boolean" },
		accentColor: { env: "CLF_ACCENT_COLOR", default: "#000000" },
		colophonText: { env: "CLF_COLOPHON_TEXT", default: "All Rights Reserved" },
	};
	let siteMetadata = {
		apiBase: "jsonapi",
		menus: [],
	};

	if (process.env.CLF_MENUS && process.env.CLF_MENUS.length > 0) {
		siteMetadata.menus = process.env.CLF_MENUS.split("|");
	}

	for (const [key, conf] of Object.entries(siteMetaSchema)) {
		if (process.env[conf.env]) {
			if (conf.type === "boolean") {
				siteMetadata[key] = getBoolFromVar(process.env[conf.env]);
			} else {
				siteMetadata[key] = process.env[conf.env];
			}
		} else {
			siteMetadata[key] = conf.default;
		}
		if (key === "privateRoute" && siteMetadata[key]) {
			// remove last character if it is a slash
			siteMetadata[key] = siteMetadata[key].replace(/\/$/, "");
		}
	}

	siteMetadata.titleTemplate = `%s · ${siteMetadata.title}`;
	siteMetadata.image = `${siteMetadata.url}/og.jpg`;
	siteMetadata.apiBaseUrl = `${siteMetadata.drupalUrl}/${siteMetadata.apiBase}`;

	siteMetadata.hasPrivateSearch =
		siteMetadata.hasSearch &&
		siteMetadata.privateRoute &&
		!getBoolFromVar(process.env.CLF_DISABLE_PRIVATE_SEARCH);

	if (getBoolFromVar(process.env.CLF_WHITELABEL)) {
		siteMetadata.titleAsText = "1";
	}

	return siteMetadata;
};
